import { PaginacionProps } from "../global/PaginacionInterface";
import { ExpedienteProps, defaultExpediente } from "../recepcion/ExpedienteInterface";


export const defaultBuscarLibroSentenciaDefinitivaResponse: BuscarLibroSentenciaDefinitivaResponse = { currentPageIndex: 0, pageCount: 0, recordCount: 0, records: [], };

export const defaultBuscarLibroSentenciaDefinitiva: BuscarLibroSentenciaDefinitiva = { idAutoridad: 0, numeroReferencia: '', idTipoConsecutivo: 0 };

export const defaultLibroSentenciaDefinitiva: LibroSentenciaDefinitivaProps = { 
    idLibroSentenciaDefinitiva: 0,
    idSentencia:                0,
    numeroSentencia:            '',
    idExpediente:               0,
    numeroExpediente:           '',
    sentidoSentencia:           '',
    prorroga:                   '',
    documentoSentencia:         '',
    observaciones:              '',
    expediente:                 defaultExpediente,
};

export interface LibroSentenciaDefinitivaProps {
    idLibroSentenciaDefinitiva: number;
    idSentencia:                number;
    numeroSentencia:            string;
    idExpediente:               number;
    numeroExpediente:           string;
    sentidoSentencia:           string;
    prorroga:                   string;
    documentoSentencia:         string;
    observaciones:              string;
    fechaCitacionSentencia?:    Date;
    fechaSentencia?:            Date;
    fechaProrroga?:             Date;
    expediente:                 ExpedienteProps;
}

export interface BuscarLibroSentenciaDefinitiva {
    idAutoridad:        number;
    numeroReferencia:   string;
    idTipoConsecutivo?: number;
}

export interface BuscarLibroSentenciaDefinitivaParams extends PaginacionProps, BuscarLibroSentenciaDefinitiva { }

export interface BuscarLibroSentenciaDefinitivaResponse {
    currentPageIndex:   number;
    pageCount:          number;
    recordCount:        number;
    records:            LibroSentenciaDefinitivaProps[];
}

export interface GuardarObservaciones {
    id:             number;
    observaciones:  string;
}

export interface DescargarInformacionParams { 
    idAutoridad:        number;
    numeroReferencia:   string;
    idTipoConsecutivo?: number;
}